import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { callSocket } from '@services/websocket/socket'
import { fetchAllCallLogs, fetchAllConversations } from '@store/actions'

interface CallAiCompletedEvent {
  call_id: string
  clinic_id: string
  db_name?: string
  status?: 'completed' | 'failed'
}

const CallAiSocketListener: React.FC = () => {
  const dispatch = useAppDispatch()
  const selectedClinic = useAppSelector((state) => state.clinic.selectedClinic)
  const dbName = useAppSelector((state) => state.auth.dbName)

  useEffect(() => {
    const handleCallAiCompleted = (event: CallAiCompletedEvent): void => {
      if (!event?.call_id) return
      if (
        event.clinic_id &&
        selectedClinic?.clinic_id &&
        event.clinic_id !== selectedClinic.clinic_id
      ) {
        return
      }
      if (event.db_name && dbName && event.db_name !== dbName) {
        return
      }
      if (
        event.status &&
        event.status !== 'completed' &&
        event.status !== 'failed'
      ) {
        return
      }

      void dispatch(fetchAllCallLogs())
      void dispatch(fetchAllConversations())
    }

    callSocket.on('call-ai-completed', handleCallAiCompleted)
    return () => {
      callSocket.off('call-ai-completed', handleCallAiCompleted)
    }
  }, [dispatch, selectedClinic?.clinic_id, dbName])

  return null
}

export default CallAiSocketListener
